import { render, staticRenderFns } from "./CommunityActivityDetail.vue?vue&type=template&id=1e61b78e&scoped=true&"
import script from "./CommunityActivityDetail.vue?vue&type=script&lang=js&"
export * from "./CommunityActivityDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommunityActivityDetail.vue?vue&type=style&index=0&id=1e61b78e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e61b78e",
  null
  
)

export default component.exports